import { Link } from "react-router-dom";
import { ArrowRight, Calculator, Building2, CalendarClock, Plane, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { TOOL_PATHS } from "@/config/tools";
import { Stagger, StaggerItem } from "@/components/Motion";

export const TOOLS = [
  { id: "profit", icon: Calculator, path: TOOL_PATHS.profit },
  { id: "setup", icon: Building2, path: TOOL_PATHS.setup },
  { id: "calendar", icon: CalendarClock, path: TOOL_PATHS.calendar },
  { id: "roadmap", icon: Plane, path: TOOL_PATHS.roadmap },
];

export default function ToolsGrid() {
  const { t } = useTranslation();
  return (
    <Stagger className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[var(--line)] border border-[var(--line)]" data-testid="tools-grid">
      {TOOLS.map(({ id, icon: Icon, path }, i) => (
        <StaggerItem key={id} className="bg-[var(--ink)]">
          <Link
            to={path}
            data-testid={`tool-card-${id}`}
            className="tool-card group flex flex-col justify-between h-full min-h-[300px] p-8 md:p-12"
          >
            <div className="flex items-start justify-between">
              <span className="tool-icon">
                <Icon size={22} strokeWidth={1.4} />
              </span>
              <span className="font-mono text-[var(--mute-2)] text-sm tracking-[0.22em]">0{i + 1}</span>
            </div>
            <div className="mt-12">
              <h3 className="display text-3xl md:text-4xl text-[var(--bone)] leading-[1.05]">{t(`tools.cards.${id}.title`)}</h3>
              <p className="mt-4 text-[var(--mute)] leading-relaxed max-w-md">{t(`tools.cards.${id}.benefit`)}</p>
              <div className="mt-8 flex flex-wrap items-center justify-between gap-4">
                <span className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.22em] text-[var(--bone-2)]/70">
                  <Clock size={12} /> {t("tools.takes2")}
                </span>
                <span className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-[var(--pewter)] group-hover:gap-3 transition-[gap] duration-300">
                  {t("tools.tryFree")} <ArrowRight size={14} className="rtl:rotate-180" />
                </span>
              </div>
            </div>
          </Link>
        </StaggerItem>
      ))}
    </Stagger>
  );
}
